import Hero from "../../components/Hero";
import HeroImage from "../../../assets/images/Blogs1.jpg";

const Blog1 = () => {
  return (
    <div className="home-page">
      <Hero
        title="Blogs"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <div className="white-container">
        <div className="white-container-content" style={{ gap: "25px" }}>
          <div className="content-semibold burgandy">
            Low-Deposit Mortgages Reach 17-Year High: What It Means for You
          </div>
          <div className="content burgandy">Apr 16, 2025</div>
          <div className="divider burgandy" />
          <div className="content grey align-left align-left">
            In a significant development for the UK housing market, the number
            of low-deposit mortgage deals—requiring just a 5% or 10% deposit—has
            reached its highest level since 2008.
          </div>
          <div className="content grey align-left">
            <strong>
              Your home may be repossessed if you do not keep up repayments on
              your mortgage
            </strong>
          </div>
          <div className="content grey align-left">
            <span>Information correct as of 16 April 2025</span>
          </div>
          <div className="content grey align-left">
            <strong>Disclaimer:</strong> This blog post provides general
            information and should not be construed as financial advice. For
            personalised guidance, please consult with a qualified financial
            advisor.
          </div>
          <div className="content grey align-left">
            <strong>Recent data from Moneyfacts</strong>
            <br />
            According to recent data from Moneyfacts, there are now 442
            mortgages available for those with a 5% deposit and 845 for those
            with a 10% deposit. This surge offers renewed hope for first-time
            buyers and others struggling to save for a substantial deposit.
          </div>
          <div className="content grey align-left" style={{ color: "var(--burgandy)" }}>
            Factors have Contributed to this Increase
          </div>
          <div className="content-semibold grey align-left">
            Why Is This Happening?
          </div>
          <div className="content grey align-left">
            <strong>1: Relaxed Lending Criteria</strong>
            <br />
            Major lenders like Halifax and Lloyds Bank have eased affordability
            assessments, allowing borrowers to qualify for larger loans. For
            instance, a typical household could now borrow approximately £38,000
            more than before.
          </div>
          <div className="content grey align-left">
            <strong>2: Competitive Mortgage Rates</strong>
            <br />
            Banks such as HSBC and the Co-operative Bank have reduced rates on
            two- and three-year fixed deals, making mortgages more affordable.
          </div>
          <div className="content grey align-left">
            <strong>3: Market Conditions</strong>
            <br />
            The easing of US trade tariffs has led to changing expectations on
            UK interest rates, prompting lenders to adjust their offerings.
          </div>
          <div className="content-semibold grey align-left">
            What Does This Mean for You?
          </div>
          <div className="content grey align-left">
            <strong>1: First-Time Buyers</strong>
            <br />
            With more low-deposit deals available, entering the property market
            has become more attainable.
          </div>
          <div className="content grey align-left">
            <strong>2: Home Movers</strong>
            <br />
            The increased borrowing capacity allows for more flexibility when
            considering your next move.
          </div>
          <div className="content grey align-left">
            <strong>3: Remortgagers</strong>
            <br />
            The competitive rates and relaxed criteria can make refinancing more
            beneficial.
          </div>
          <div className="content-semibold grey align-left">Next Steps</div>
          <div className="content grey align-left">
            To make the most of these developments:
            <ul>
              <li>
                <strong>Consult a Mortgage Adviser:</strong> Professional
                guidance can help you navigate the options and find the best
                deal tailored to your circumstances.
              </li>
              <li>
                <strong>Compare Offers:</strong> Use online tools and resources
                to compare different mortgage products and lenders.
              </li>
              <li>
                <strong>Prepare Your Finances:</strong> Ensure your credit score
                and financial documents are in order to improve your chances of
                securing favourable terms.
              </li>
            </ul>
          </div>
          <div className="content grey align-left">
            The current landscape presents a unique opportunity for those
            looking to step onto or move within the property ladder. With the
            right information and support, your homeownership goals are within
            reach.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog1;
